import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import MzAlert from "@markaaz/ui/MzAlert";
import I18n from "i18next";
import MzButton from "@markaaz/ui/MzButton";
import CheckboxField from "components/Common/CheckboxField/CheckboxField";
import CheckGrid from "components/Common/CheckGrid";

const sx = {
  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    width: "768px"
  },
  heading: {
    color: "darkBlue.c100"
  },
  wrapper: {
    width: "740px",
    gap: "10px",
    color: "darkBlue.c100",
    display: "flex",
    flexDirection: "column"
  },
  pageWrapper: {
    gap: "40px",
    display: "flex",
    flexDirection: "column"
  },
  body: {
    color: "darkBlue.c100",
    marginBottom: "40px",
    maxWidth: "860px"
  }
};


const contractTerms = [
  {
    "section": "Entry Points",
    "description": "Advanced Matching provides several additional options depending on the input values.",
    "items": [
      { "id": 10, "label": "Standard Matching", "checkboxKey": "standardMatchingEnabled" },
      { "id": 9, "label": "Advanced Matching", "checkboxKey": "advancedMatchingEnabled" },
      { "id": 11, "label": "Markaaz Search API", "checkboxKey": "bizSearchEnabled" }
    ],
    "sx": {
      "height": "300px"
    }
  },
  {
    "section": "Data Objects",
    "description": "The data objects available are contracted items. Your terms are listed below. If you need to add or remove data objects, please contact your account manager to change your contract terms.",
    "items": [
      { "id": 1, "label": "Firmographic", "checkboxKey": "bizFirmograhicEnabled" },
      { "id": 2, "label": "Business Health", "checkboxKey": "bizHealthEnabled" },
      { "id": 3, "label": "Compliance", "checkboxKey": "bizComplianceEnabled" },
      { "id": 4, "label": "Company Hierarchy", "checkboxKey": "bizHeirarchyEnabled" },
      { "id": 5, "label": "Diversity", "checkboxKey": "bizDiversityEnabled" },
      { "id": 6, "label": "Name Matching", "checkboxKey": "officerNameMatchingEnabled" }
    ],
    "sx": {
      "height": "422px"
    }
  },
  {
    "section": "Monitoring",
    "description": "Markaaz provides monthly Business and daily Compliance monitoring reports. These reports are delivered based on your contract terms. To make changes, please contact your account manager.",
    "items": [
      { "id": 7, "label": "Business", "checkboxKey": "businessMonitoringEnabled" },
      { "id": 8, "label": "Compliance", "checkboxKey": "complianceMonitoringEnabled" }
    ],
    "sx": {
      "height": "246px",
      "marginTop": "30px"
    }
  },
  {
    "section": "Business Decisioning API",
    "description": "This API relies on a customized set of decision parameters that are instrumental in evaluating a business entity according to the specified values outlined by each partner.",
    "items": [{ "id": 11, "label": "Decisioning API", "checkboxKey": "bizDecisionEnabled" }],
    "sx": {
      "height": "202px"
    }
  }
]

export default function ContractTermsMain({
  dataObjectColumns,
  monitoringColumns,
  matchingColumns,
  showNotification,
  values,
  submitInProgress,
  isSuperUser,
  userRole,
  onAlertClose,
  onSubmit,
  onCheckboxChange,
  onTermsButtonClick,
}) {

  return (
    <> <Box sx={sx.headerContent}>
      <Typography variant="h4" sx={sx.heading}>
        {
          I18n.t("contractTerms.contractTerms")
        }
      </Typography>
      <MzButton>
        <Typography variant="button2" onClick={onTermsButtonClick}>
          Master Terms & Conditions
        </Typography>
      </MzButton>
    </ Box >
      <Box sx={sx.pageWrapper}>
        <Typography variant="body2" sx={sx.body}>
          {I18n.t("contractTerms.contractTermsDsc")}
        </Typography>
        {contractTerms.map((contract) => {
          return (
            <Box sx={{ ...sx.pageWrapper, ...contract.sx }}>
              <Box sx={sx.wrapper}>
                <Typography variant="h6">{contract.section}</Typography>
                <Typography variant="body2">{contract.description}</Typography>
              </Box>
              {isSuperUser && userRole === "STAFF_SUPER_USER" ? (
                <Box>
                  {contract.items.map((items) => {
                    return (
                      <CheckboxField items={items} rowData={items} onCheckboxChange={onCheckboxChange} values={values} />
                    );
                  })}
                </Box>
              ) : (
                <CheckGrid
                  columns={
                    contract.section === "Monitoring"
                      ? monitoringColumns
                      : contract.section === "Matching"
                        ? matchingColumns
                        : dataObjectColumns
                  }
                  rows={contract.items.map((item) => {
                    let row = item;
                    row.checked = values[item.checkboxKey];
                    return row;
                  })}
                />
              )}
            </Box>
          );
        })}

        <Stack direction="row" gap={10} alignItems="center">
          {isSuperUser && userRole === "STAFF_SUPER_USER" && (
            <MzButton variant="contained" color="primary" size="large" onClick={onSubmit} loading={submitInProgress}>
              {I18n.t("common.submit")}
            </MzButton>
          )}
          {showNotification.message && (
            <MzAlert
              sx={{ alignItems: "center" }}
              severity={showNotification.type === "success" ? "success" : "error"}
              onClose={onAlertClose}
            >
              {showNotification.message}
            </MzAlert>
          )}
        </Stack>
      </Box></>
  );
}
